import {
  FC,
  RefObject,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import React from 'react';
import {
  Image,
  ScrollView,
  StyleSheet,
  TextInput as TextInputRN,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { COLORS, FONTS } from '../../../constants';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { Text } from 'react-native';
import { IDish, IExtraDish } from '../../../types/dishes.types';
import ExtraDishItem from './ExtraDishItem';
import Swiper from 'react-native-web-swiper';
import RadioButton from '../../../components/RadioButton/RadioButton';
import { TextInput } from '../../../components/TextInput/TextInput';
import { Button } from '../../../components/Button';
import DatetimeInfo from './DatetimeInfo';
import { STYLE_VARS } from '../../../constants/style-vars';
import DropDown from '../../../components/DropDown';
import { ICamp, IMeal } from '../../../types/camp.types';
import { IBookingState } from '../types';
import {
  convertToAmPm,
  generateTimeArray,
  parseTime,
} from '../../../services/utils';
import { ErrorMessage, Field, FieldProps, Formik } from 'formik';
import * as yup from 'yup';
import {
  FormComponent,
  FormStructure,
} from '../../../components/FormHelper/FormHelper.types';
import CampApi from '../../../services/api/camp.api';
import { Alert } from '../../../services/alert';
import MobileInput from '../../../components/MobileInput/MobileInput';
import { Loading } from '../../../components';
import dayjs from 'dayjs';
import RenderHTML from 'react-native-render-html';
import { convertMobileInputData } from '../../../services/utils/phoneConvert';
import ProductTable from './ProductTable';
import RoomInfor from './RoomInfor';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../services/redux';
import {
  addToCart,
  updateCartItemData,
  updateDishItems,
} from '../../../services/redux/reducers/CartSlice';
import { IActivity, IExtraActivity } from '../../../types/activities.types';
import ActivityApi from '../../../services/api/activity.api';
import ExtraActivityItem from './ExtraActivityItem';
import {
  getDatesBetween,
  isSameDate,
} from '../../../services/utils/dateConvert';
import { DISH_TYPES } from '../../../constants/dishs';
import { MealItem } from './Meal/MealItem';
import { InCludedMealItem } from './Meal/InCludedMealItem';
import AdditionalMealItem from './Meal/AdditionalMealItem';
import AddtionalActivityItem from './Activities/AddtionalActivityItem';
import { IS_WEB } from '../../../constants/platform';
import { DATE_TYPE } from '../../../constants/activity';

type Step2Props = {
  onSubmit?: () => void;
  booking: ICamp;
  state: IBookingState;
  setState: (state: Partial<IBookingState>) => void;
  scrollRef?: RefObject<ScrollView>;
  handleSetStep: (step: number) => void;
  cartId: string;
};

type PositionProps = {
  y: number;
  height: number;
};

const Step2: FC<Step2Props> = ({
  onSubmit,
  booking,
  setState,
  state,
  scrollRef,
  handleSetStep,
  cartId,
}) => {
  const betweenDates = getDatesBetween(
    state.start_date,
    state.end_date,
    booking.room_availability
  );
  const isDesktop = useIsDesktop();
  const dispatch = useDispatch();
  const [dishes, setDishes] = useState<IDish[]>([]);
  const [extraDishes, setExtraDishes] = useState<IExtraDish[]>(
    state.extra_dishes
  );
  const [activities, setActivities] = useState<IActivity[]>([]);
  const [extraActivities, setExtraActivities] = useState<IExtraActivity[]>(
    state.extra_activities
  );
  const [isLoadingActivities, setIsLoadingActivities] =
    useState<boolean>(false);

  const [isLoadingDishes, setIsLoadingDishes] = useState<boolean>(false);
  const [bookingTimePosition, setBookingTimePosition] = useState<PositionProps>(
    { y: 0, height: 0 }
  );
  const [dinnerMealPosition, setDinnerMealPosition] = useState<PositionProps>({
    y: 0,
    height: 0,
  });
  const [vegetarianPosition, setVegetarianPosition] = useState<PositionProps>({
    y: 0,
    height: 0,
  });
  const [emerPosition, setEmerPosition] = useState<PositionProps>({
    y: 0,
    height: 0,
  });

  const handleScroll = (position: PositionProps) => {
    scrollRef?.current?.scrollTo({ y: position.y + position.height });
  };

  const initData = useMemo(() => {
    return {
      checkin_time: '',
      checkout_time: '',
      dinner_meal: state.dinner_meal,
      is_vegetarian: state.is_vegetarian,
      emer_first_name: state.emergency_first_name,
      emer_last_name: state.emergency_last_name,
      emer_phone: `${state.emergency_phone_country},${state.emergency_phone_number}`,
      emer_relationship: state.emergency_relationship,
    };
  }, [state]);

  const breakfastDishes = useMemo(() => {
    return dishes.filter((dish) =>
      dish.types.some((type) => type.id === DISH_TYPES.BREAKFAST)
    );
  }, [dishes]);

  const lunchDishes = useMemo(() => {
    return dishes.filter((dish) =>
      dish.types.some((type) => type.id === DISH_TYPES.LUNCH)
    );
  }, [dishes]);

  const dinnerDishes = useMemo(() => {
    return dishes.filter((dish) =>
      dish.types.some((type) => type.id === DISH_TYPES.DINNER)
    );
  }, [dishes]);

  const addOrUpdateDish = useCallback(
    (newDish: IDish, type: number, quantity: number) => {
      betweenDates.forEach((date) => {
        const existingDish = extraDishes.find((extraDish) => {
          return (
            extraDish.dish.id === newDish.id &&
            extraDish.date === date &&
            extraDish.type === type
          );
        });

        if (!existingDish) {
          setExtraDishes((prevExtraDishes) => {
            return [
              ...prevExtraDishes,
              {
                dish: newDish,
                quantity: quantity,
                date: date,
                type: type,
              },
            ];
          });
        } else {
          setExtraDishes((prevExtraDishes) => {
            return prevExtraDishes.map((item) => {
              return {
                ...item,
                quantity:
                  item.dish.id === newDish.id &&
                  item.date === date &&
                  item.type === type
                    ? quantity + item.quantity
                    : item.quantity,
              };
            });
          });
        }
      });
    },
    [betweenDates, extraDishes]
  );

  const handleUpdateQuantityDish = useCallback(
    (dish: IExtraDish, type: 'add' | 'minus') => {
      setExtraDishes((prevExtraDishes) => {
        return prevExtraDishes.map((extraDish) => {
          if (
            extraDish.dish.id === dish.dish.id &&
            extraDish.date === dish.date &&
            extraDish.type === dish.type
          ) {
            if (type === 'add' && extraDish.quantity < state.total_guest) {
              return {
                ...extraDish,
                quantity: extraDish.quantity + 1,
              };
            } else if (type === 'minus' && extraDish.quantity > 0) {
              return {
                ...extraDish,
                quantity: extraDish.quantity - 1,
              };
            } else {
              return extraDish;
            }
          } else {
            return extraDish;
          }
        });
      });
    },
    [state.total_guest]
  );

  const addOrUpdateActivities = useCallback(
    (newActivity: IActivity, peopleNum: number) => {
      let isTooMuchPeople = false;

      betweenDates.forEach((date) => {
        const existingActivity = extraActivities.find((extraActivity) => {
          return (
            extraActivity.activity.id === newActivity.id &&
            extraActivity.date === date
          );
        });

        if (!existingActivity) {
          setExtraActivities((prevExtraActivities) => {
            return [
              ...prevExtraActivities,
              {
                activity: newActivity,
                attendees: peopleNum,
                date: date,
              },
            ];
          });
        } else {
          if (existingActivity.attendees + peopleNum > state.total_guest) {
            isTooMuchPeople = true;
          } else {
            setExtraActivities((prevExtraActivities) => {
              return prevExtraActivities.map((item) => {
                if (item.activity.id === newActivity.id && item.date === date) {
                  return {
                    ...item,
                    attendees: peopleNum + item.attendees,
                  };
                } else {
                  return item;
                }
              });
            });
          }
        }
      });

      if (isTooMuchPeople) {
        Alert.alert(
          '',
          'You cannot select a number of activity people greater than the total number of people of the booking.'
        );
      } else {
        Alert.alert('Activity added to your booking!', '', [
          {
            text: 'Continue booking',
            onPress: () => {},
          },
        ]);
      }
    },
    [betweenDates, extraActivities, state.total_guest]
  );

  const handleUpdateAttendeesActivity = useCallback(
    (activity: IExtraActivity, type: 'add' | 'minus') => {
      setExtraActivities((prevExtraActivities) => {
        return prevExtraActivities.map((extraActivity) => {
          if (
            extraActivity.activity.id === activity.activity.id &&
            extraActivity.date === activity.date
          ) {
            if (type === 'add' && extraActivity.attendees < state.total_guest) {
              return {
                ...extraActivity,
                attendees: extraActivity.attendees + 1,
              };
            } else if (type === 'minus' && extraActivity.attendees > 0) {
              return {
                ...extraActivity,
                attendees: extraActivity.attendees - 1,
              };
            } else {
              return extraActivity;
            }
          } else {
            return extraActivity;
          }
        });
      });
    },
    [state.total_guest]
  );

  const getDishes = useCallback(async () => {
    setIsLoadingDishes(true);
    CampApi.getDishes()
      .then((res) => {
        setDishes(res.data.data);
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoadingDishes(false);
      });
  }, []);

  const getActivities = useCallback(
    async () => {
      setIsLoadingActivities(true);
      ActivityApi.getActivities({
        is_paid: true,
        // start_time: `${state.start_date} ${dayjs(
        //   parseTime(booking.start_time)
        // ).format('HH:mm')}`,
        // end_time: `${state.end_date} ${dayjs(parseTime(booking.end_time)).format(
        //   'HH:mm'
        // )}`,
      })
        .then((res) => {
          setActivities(res.data.data);
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoadingActivities(false);
        });
    },
    [
      // state.start_date,
      // booking.start_time,
      // state.end_date,
      // booking.end_time
    ]
  );

  const renderForm = useCallback((component: FormComponent) => {
    switch (component.type) {
      case 'dropdown':
        return (
          <View
            key={component.name}
            style={{ marginBottom: 10, zIndex: component.zIndex }}
          >
            <Text
              style={{
                fontFamily: FONTS.AvenirMedium,
                fontWeight: '800',
                fontSize: 15,
                color: COLORS.LIGHT_BLACK,
                letterSpacing: 1,
                marginBottom: 5,
              }}
            >
              {component.label}:
            </Text>
            <Field name={component.name}>
              {({ field, form }: FieldProps) => (
                <View style={{ width: 180 }}>
                  <DropDown
                    items={component.items || []}
                    placeholder={'Select time'}
                    dropdownStyle={{
                      borderColor: '#DDDDE3',
                      paddingVertical: 6,
                      borderRadius: 8,
                    }}
                    textStyle={{
                      fontFamily: FONTS.AvenirMedium,
                      fontWeight: '500',
                      fontSize: 16,
                      color: COLORS.GREY,
                    }}
                    dropDownContainerStyled={{
                      top: 36,
                      minHeight: 10,
                    }}
                    dropDownContainerTextStyle={{
                      fontFamily: FONTS.AvenirMedium,
                      fontWeight: '500',
                      fontSize: 14,
                      color: COLORS.GREY,
                    }}
                    setValues={(value) => {
                      form.setFieldValue(field.name, value.value);
                    }}
                  />
                  <ErrorMessage
                    name={field.name}
                    render={(errorMessage: string) => (
                      <Text style={{ color: 'red', marginTop: 5 }}>
                        {errorMessage}
                      </Text>
                    )}
                  />
                </View>
              )}
            </Field>
          </View>
        );
      case 'mobilePhone':
        return (
          <Field name={component.name}>
            {({ field }: FieldProps) => (
              <View style={[{ width: '100%', marginBottom: 5 }]}>
                <MobileInput
                  setValues={(value) => {
                    field.onChange(field.name)(value);
                  }}
                  dropdownStyle={{
                    width: 70,
                    padding: 5,
                    paddingLeft: 5,
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingEnd: 5,
                    borderRadius: 5,
                  }}
                  dropdownTextStyle={{
                    fontSize: 13,
                    marginRight: 0,
                  }}
                  buttonStyle={{
                    width: 10,
                    height: 6,
                  }}
                  textInputStyle={{
                    width: '100%',
                    paddingVertical: 6,
                    paddingHorizontal: 6,
                    height: 'auto',
                    fontSize: 14,
                  }}
                  initValue={field.value}
                />
                <ErrorMessage
                  name={field.name}
                  render={(errorMessage: string) => (
                    <Text style={{ color: 'red', marginTop: 5 }}>
                      {errorMessage}
                    </Text>
                  )}
                />
              </View>
            )}
          </Field>
        );
      default:
        return (
          <Field name={component.name}>
            {({ field }: FieldProps) => (
              <View>
                <TextInput
                  style={[
                    STYLE_VARS.textInputMini as TextStyle,
                    { marginBottom: 5, fontSize: 14 },
                  ]}
                  placeholder=""
                  value={field.value}
                  onChangeText={(text) => {
                    field.onChange(field.name)(text);
                  }}
                />
                <ErrorMessage
                  name={field.name}
                  render={(errorMessage: string) => (
                    <Text style={{ color: 'red', marginTop: 5 }}>
                      {errorMessage}
                    </Text>
                  )}
                />
              </View>
            )}
          </Field>
        );
    }
  }, []);

  const openPopupDish = useCallback(
    (dish: IDish, type: number, quantity: number) => {
      const br = IS_WEB ? '<br/>' : '\n';
      var dishType = '';
      switch (type) {
        case DISH_TYPES.BREAKFAST:
          dishType = 'Breakfast';
          break;
        case DISH_TYPES.LUNCH:
          dishType = 'Lunch';
          break;
        case DISH_TYPES.DINNER:
          dishType = 'Dinner';
          break;
      }
      const alertTitle = `Add ${dish.name} to your booking?`;
      const alertMessage = `Name: ${
        dish.name
      }${br}Type: ${dishType}${br}Price: $${
        dish.price
      } HKD${br}No. Of Meals: ${quantity}${br}Total Price: $${
        dish.price * quantity
      } HKD`;
      Alert.alert(alertTitle, alertMessage, [
        {
          text: 'Yes',
          onPress: () => {
            addOrUpdateDish(dish, type, quantity);
            Alert.alert('Dish added to your booking!', '', [
              {
                text: 'Continue booking',
                onPress: () => {},
              },
            ]);
          },
        },
        {
          text: 'Cancel',
          onPress: () => {},
        },
      ]);
    },
    [addOrUpdateDish]
  );

  const openPopupActivity = useCallback(
    (activity: IActivity, peopleNum: number) => {
      const br = IS_WEB ? '<br/>' : '\n';
      const activityName = `Name: ${activity.name}`;
      const date =
        activity.date_type.value !== DATE_TYPE.NORMAL
          ? activity.date_type.name
          : activity.start_date === activity.end_date
          ? `Date: ${dayjs(activity.start_date).format('MMMM DD, YYYY')}`
          : `Start: ${dayjs(activity.start_date).format(
              'MMMM DD, YYYY'
            )}${br}End: ${dayjs(activity.end_date).format('MMMM DD, YYYY')}`;
      const time = `${convertToAmPm(activity.start_time)} - ${convertToAmPm(
        activity.end_time
      )}`;
      const venue = `Venue: ${activity.venue}`;
      const noOfPeople = `No. Of People: ${peopleNum}`;
      const totalPrice = `Total Price: $${activity.price * peopleNum} HKD`;
      const alertTitle = `Add ${activity.name} to your booking?`;
      const alertMessage = `${activityName}${br}${date}${br}${time}${br}${venue}${br}${noOfPeople}${br}${totalPrice}`;
      Alert.alert(alertTitle, alertMessage, [
        {
          text: 'Yes',
          onPress: () => {
            addOrUpdateActivities(activity, peopleNum);
          },
        },
        {
          text: 'Cancel',
          onPress: () => {},
        },
      ]);
    },
    [addOrUpdateActivities]
  );

  const renderDishSwiper = useCallback(
    (dishes: IDish[], type: number) => {
      var allGroup: React.JSX.Element[] = [];
      var group: React.JSX.Element[] = [];
      dishes.map((dish, index) => {
        group.push(
          <View
            key={dish.id}
            style={{
              flex: 0.25,
            }}
          >
            <ExtraDishItem
              item={dish}
              onAddToCart={openPopupDish}
              type={type}
              maxQuantity={state.total_guest}
            />
          </View>
        );
        if (
          ((index + 1) % 4 === 0 && index !== 0) ||
          index === dishes.length - 1
        ) {
          allGroup.push(
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                gap: 20,
              }}
            >
              {group}
            </View>
          );
          group = [];
        }
      });

      return (
        <Swiper
          controlsProps={{
            prevPos: false,
            nextPos: false,
            DotComponent: ({ index, isActive, onPress }) => (
              <>
                <View style={{ marginHorizontal: 2 }}>
                  <View
                    style={[
                      {
                        height: 10,
                        borderRadius: 10,
                      },
                      isActive
                        ? {
                            width: 18,
                            backgroundColor: '#5E5D5D',
                          }
                        : {
                            width: 10,

                            backgroundColor: '#C9C9C9',
                          },
                    ]}
                  ></View>
                </View>
              </>
            ),
            dotsTouchable: true,
          }}
          timeout={5}
          loop
          from={1}
        >
          {allGroup}
        </Swiper>
      );
    },
    [openPopupDish, state.total_guest]
  );

  const renderActivitySwiper = useCallback(() => {
    var allGroup: React.JSX.Element[] = [];
    var group: React.JSX.Element[] = [];
    activities.map((activity, index) => {
      group.push(
        <View
          key={activity.id}
          style={{
            flex: 0.25,
            //minWidth: 250,
          }}
        >
          <ExtraActivityItem
            item={activity}
            onAddToCart={openPopupActivity}
            maxPeople={state.total_guest}
          />
        </View>
      );
      if (
        ((index + 1) % 4 === 0 && index !== 0) ||
        index === activities.length - 1
      ) {
        allGroup.push(
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              flexWrap: 'wrap',
              gap: 20,
            }}
          >
            {group}
          </View>
        );
        group = [];
      }
    });

    return (
      <Swiper
        controlsProps={{
          prevPos: false,
          nextPos: false,
          DotComponent: ({ index, isActive, onPress }) => (
            <>
              <View style={{ marginHorizontal: 2 }}>
                <View
                  style={[
                    {
                      height: 10,
                      borderRadius: 10,
                    },
                    isActive
                      ? {
                          width: 18,
                          backgroundColor: '#5E5D5D',
                        }
                      : {
                          width: 10,

                          backgroundColor: '#C9C9C9',
                        },
                  ]}
                ></View>
              </View>
            </>
          ),
          dotsTouchable: true,
        }}
        timeout={5}
        loop
        from={1}
      >
        {allGroup}
      </Swiper>
    );
  }, [activities, openPopupActivity, state.total_guest]);

  const renderDinnerMeal = useMemo(() => {
    return (
      <View
        style={{
          marginBottom: 20,
          zIndex: 2,
        }}
        onLayout={(event) => {
          const { layout } = event.nativeEvent;
          const { height, y } = layout;

          setDinnerMealPosition({ y: y, height: height });
        }}
      >
        <Text style={styles.itemTitle}>Select Dinner Meal Option:</Text>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            width: '100%',
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              gap: 20,
              marginRight: isDesktop() ? 20 : 10,
            }}
          >
            <View
              style={[styles.mealWrapper, { backgroundColor: '#1A94FF4F' }]}
            >
              <Text
                style={[
                  styles.mealText,
                  { color: '#1A94FF' },
                  !isDesktop() && { fontSize: 17 },
                ]}
              >
                Dinner
              </Text>
            </View>
            {isDesktop() && (
              <Text
                style={{
                  fontFamily: FONTS.AvenirMedium,
                  fontWeight: '500',
                  fontSize: 16,
                  color: COLORS.GREY,
                }}
              >
                Select Meal Option:
              </Text>
            )}
          </View>
          {booking.dinner_meal && booking.dinner_meal.length > 0 && (
            <Field
              name={'dinner_meal'}
              validate={(value: any) => {
                let error;
                if (booking.dinner_meal.length > 0 && !value) {
                  error = 'Please select dinner meal';
                }

                return error;
              }}
            >
              {({ field, form }: FieldProps) => (
                <View>
                  <View
                    style={{
                      flexDirection: 'column',
                    }}
                  >
                    {booking.dinner_meal &&
                      booking.dinner_meal.map((item, index) => {
                        const zIndex = booking.dinner_meal.length - index;

                        return (
                          <View
                            style={[
                              styles.dinnerOption,
                              {
                                marginBottom: 15,
                                gap: isDesktop() ? 20 : 10,
                                zIndex: zIndex,
                              },
                            ]}
                          >
                            <TouchableOpacity
                              style={[
                                styles.checkbox,
                                field.value?.name === item.name &&
                                  styles.checkedCheckbox,
                              ]}
                              onPress={() => {
                                form.setFieldValue('dinner_meal', item);
                              }}
                            >
                              {field.value?.name === item.name && (
                                <Text style={styles.checkIcon}>✓</Text>
                              )}
                            </TouchableOpacity>
                            <View style={{ width: 180 }}>
                              <MealItem meal={item} />
                            </View>
                          </View>
                        );
                      })}
                  </View>
                  <ErrorMessage
                    name={field.name}
                    render={(errorMessage: string) => (
                      <Text style={{ color: 'red', marginTop: 5 }}>
                        {errorMessage}
                      </Text>
                    )}
                  />
                </View>
              )}
            </Field>
          )}
        </View>
      </View>
    );
  }, [booking.dinner_meal, isDesktop]);

  const renderExtraDishes = useMemo(() => {
    return (
      <>
        <View
          style={{
            borderBottomWidth: 1,
            borderBottomColor: COLORS.DIVIDER_GREY,
            marginBottom: 20,
          }}
        >
          {isLoadingDishes === false && dishes.length !== 0 && (
            <View>
              <Text style={styles.itemTitle}>Select Extra Meals</Text>
              {/* Breakfast */}
              {breakfastDishes.length > 0 && (
                <View style={styles.addtionalMealWrapper}>
                  <Text style={styles.itemSubTitle}>Breakfast</Text>
                  {isDesktop() ? (
                    <View
                      style={{
                        height: 440,
                      }}
                    >
                      {renderDishSwiper(breakfastDishes, DISH_TYPES.BREAKFAST)}
                    </View>
                  ) : (
                    <View
                      style={{
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        gap: 10,
                      }}
                    >
                      {breakfastDishes.map((dish, index) => {
                        return (
                          <View
                            style={{
                              width: '48%',
                            }}
                          >
                            <ExtraDishItem
                              item={dish}
                              onAddToCart={openPopupDish}
                              type={DISH_TYPES.BREAKFAST}
                              maxQuantity={state.total_guest}
                            />
                          </View>
                        );
                      })}
                    </View>
                  )}
                </View>
              )}
              {/* Lunch */}
              {lunchDishes.length > 0 && (
                <View style={styles.addtionalMealWrapper}>
                  <Text style={styles.itemSubTitle}>Lunch</Text>
                  {isDesktop() ? (
                    <View
                      style={{
                        height: 440,
                      }}
                    >
                      {renderDishSwiper(lunchDishes, DISH_TYPES.LUNCH)}
                    </View>
                  ) : (
                    <View
                      style={{
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        gap: 10,
                      }}
                    >
                      {lunchDishes.map((dish, index) => {
                        return (
                          <View
                            style={{
                              width: '48%',
                            }}
                          >
                            <ExtraDishItem
                              item={dish}
                              onAddToCart={openPopupDish}
                              type={DISH_TYPES.LUNCH}
                              maxQuantity={state.total_guest}
                            />
                          </View>
                        );
                      })}
                    </View>
                  )}
                </View>
              )}
              {/* Dinner */}
              {dinnerDishes.length > 0 && (
                <View style={styles.addtionalMealWrapper}>
                  <Text style={styles.itemSubTitle}>Dinner</Text>
                  {isDesktop() ? (
                    <View
                      style={{
                        height: 440,
                      }}
                    >
                      {renderDishSwiper(dinnerDishes, DISH_TYPES.DINNER)}
                    </View>
                  ) : (
                    <View
                      style={{
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        gap: 10,
                      }}
                    >
                      {dinnerDishes.map((dish, index) => {
                        return (
                          <View
                            style={{
                              width: '48%',
                            }}
                          >
                            <ExtraDishItem
                              item={dish}
                              onAddToCart={openPopupDish}
                              type={DISH_TYPES.DINNER}
                              maxQuantity={state.total_guest}
                            />
                          </View>
                        );
                      })}
                    </View>
                  )}
                </View>
              )}
            </View>
          )}
          {isLoadingDishes && (
            <View style={{ marginVertical: 10 }}>
              <Loading />
            </View>
          )}
        </View>
      </>
    );
  }, [
    dishes,
    isDesktop,
    isLoadingDishes,
    openPopupDish,
    renderDishSwiper,
    breakfastDishes,
    lunchDishes,
    dinnerDishes,
    state.total_guest,
  ]);

  const renderAddtionalMeals = useMemo(() => {
    return extraDishes.length > 0 ? (
      <View>
        <View>
          <Text style={styles.itemTitle}>Select Additional Meals</Text>
        </View>
        {betweenDates.map((date, index) => {
          const dateDishes = extraDishes.filter((dish) => dish.date === date);
          const breakfastDateDishes = dateDishes.filter(
            (dish) => dish.type === DISH_TYPES.BREAKFAST
          );
          const lunchDateDishes = dateDishes.filter(
            (dish) => dish.type === DISH_TYPES.LUNCH
          );
          const dinnerDateDishes = dateDishes.filter(
            (dish) => dish.type === DISH_TYPES.DINNER
          );

          return (
            <View style={{ marginBottom: 10 }}>
              <Text style={styles.itemSubTitle}>
                {`Day ${index + 1} - ${dayjs(new Date(date)).format(
                  'DD/MM/YYYY'
                )}`}
              </Text>
              {breakfastDateDishes.length > 0 && (
                <View style={styles.addtionalMealWrapper}>
                  <Text style={styles.itemSubTitle}>Breakfast</Text>
                  <View
                    style={{
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      gap: 10,
                    }}
                  >
                    {breakfastDateDishes.map((dish, index) => {
                      return (
                        <View
                          style={{
                            width: isDesktop() ? '24%' : '48%',
                          }}
                        >
                          <AdditionalMealItem
                            item={dish}
                            onUpdateQuantity={handleUpdateQuantityDish}
                          />
                        </View>
                      );
                    })}
                  </View>
                </View>
              )}
              {lunchDateDishes.length > 0 && (
                <View style={styles.addtionalMealWrapper}>
                  <Text style={styles.itemSubTitle}>Lunch</Text>
                  <View
                    style={{
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      gap: 10,
                    }}
                  >
                    {lunchDateDishes.map((dish, index) => {
                      return (
                        <View
                          style={{
                            width: isDesktop() ? '24%' : '48%',
                          }}
                        >
                          <AdditionalMealItem
                            item={dish}
                            onUpdateQuantity={handleUpdateQuantityDish}
                          />
                        </View>
                      );
                    })}
                  </View>
                </View>
              )}
              {dinnerDateDishes.length > 0 && (
                <View style={styles.addtionalMealWrapper}>
                  <Text style={styles.itemSubTitle}>Dinner</Text>
                  <View
                    style={{
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      gap: 10,
                    }}
                  >
                    {dinnerDateDishes.map((dish, index) => {
                      return (
                        <View
                          style={{
                            width: isDesktop() ? '24%' : '48%',
                          }}
                        >
                          <AdditionalMealItem
                            item={dish}
                            onUpdateQuantity={handleUpdateQuantityDish}
                          />
                        </View>
                      );
                    })}
                  </View>
                </View>
              )}
            </View>
          );
        })}
      </View>
    ) : (
      <></>
    );
  }, [betweenDates, extraDishes, handleUpdateQuantityDish, isDesktop]);

  const renderExtraActivities = useMemo(() => {
    return activities.length > 0 ? (
      <View
        style={{
          borderBottomWidth: 1,
          borderBottomColor: COLORS.DIVIDER_GREY,
          marginBottom: 20,
        }}
      >
        {isLoadingActivities === false && activities.length !== 0 && (
          <View
            style={{
              marginBottom: 20,
            }}
          >
            <Text style={styles.itemTitle}>Select Extra Activities</Text>
            {isDesktop() ? (
              <View
                style={{
                  height: 470,
                }}
              >
                {renderActivitySwiper()}
              </View>
            ) : (
              <View
                style={{
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: 10,
                }}
              >
                {activities.map((activity, index) => {
                  return (
                    <View
                      style={{
                        width: '48%',
                      }}
                    >
                      <ExtraActivityItem
                        item={activity}
                        onAddToCart={openPopupActivity}
                        maxPeople={state.total_guest}
                      />
                    </View>
                  );
                })}
              </View>
            )}
          </View>
        )}
        {isLoadingActivities && (
          <View style={{ marginVertical: 10 }}>
            <Loading />
          </View>
        )}
      </View>
    ) : (
      <></>
    );
  }, [
    isLoadingActivities,
    activities,
    isDesktop,
    renderActivitySwiper,
    openPopupActivity,
    state.total_guest,
  ]);

  const renderAddtionalActivities = useMemo(() => {
    return extraActivities.length > 0 ? (
      <View>
        <View>
          <Text style={styles.itemTitle}>Select Additional Activities</Text>
        </View>
        {betweenDates.map((date, index) => {
          const dateActivities = extraActivities.filter(
            (extraActivity) => extraActivity.date === date
          );

          return (
            <View style={{ marginBottom: 10 }}>
              <Text style={styles.itemSubTitle}>
                {`Day ${index + 1} - ${dayjs(new Date(date)).format(
                  'DD/MM/YYYY'
                )}`}
              </Text>
              <View style={styles.addtionalActivityWrapper}>
                <View
                  style={{
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    gap: 10,
                  }}
                >
                  {dateActivities.map((activity, index) => {
                    return (
                      <View
                        style={{
                          width: isDesktop() ? '24%' : '48%',
                        }}
                      >
                        <AddtionalActivityItem
                          item={activity}
                          onUpdateAttendees={handleUpdateAttendeesActivity}
                        />
                      </View>
                    );
                  })}
                </View>
              </View>
            </View>
          );
        })}
      </View>
    ) : (
      <></>
    );
  }, [betweenDates, extraActivities, handleUpdateAttendeesActivity, isDesktop]);

  const renderEmergencyContact = useMemo(() => {
    const structure: FormStructure = {
      components: [
        {
          label: 'First Name',
          name: 'emer_first_name',
          type: 'text',
        },
        {
          label: 'Last Name',
          name: 'emer_last_name',
          type: 'text',
        },
        {
          label: 'Phone Number',
          name: 'emer_phone',
          type: 'mobilePhone',
          zIndex: 2,
        },
        {
          label: 'Relationship',
          name: 'emer_relationship',
          type: 'text',
        },
      ],
    };

    return (
      <View
        style={{
          marginBottom: 20,
        }}
        onLayout={(event) => {
          const { layout } = event.nativeEvent;
          const { height, y } = layout;

          setEmerPosition({ y: y, height: height });
        }}
      >
        <Text style={styles.itemTitle}>Add Emergency Contact</Text>
        <View
          style={[
            isDesktop()
              ? { flexDirection: 'row', flexWrap: 'wrap' }
              : { flexDirection: 'column' },
          ]}
        >
          {structure.components.map((item, index) => {
            return (
              <View
                style={{
                  width: isDesktop() ? '50%' : '100%',
                  flexDirection: 'row',
                  marginBottom: 5,
                }}
                key={index}
              >
                <Text style={[styles.contactText, { width: '40%' }]}>
                  {item.label}:
                </Text>
                <View style={{ width: '55%' }}>{renderForm(item)}</View>
              </View>
            );
          })}
        </View>
      </View>
    );
  }, [isDesktop, renderForm]);

  useEffect(() => {
    getDishes();
    getActivities();
  }, [getDishes, getActivities]);

  useEffect(() => {
    dispatch(
      updateCartItemData({
        id: cartId,
        data: {
          extra_dishes: extraDishes,
          extra_activities: extraActivities,
        },
        step: 2,
      })
    );
  }, [dispatch, extraDishes, extraActivities, cartId]);

  return (
    <View
      style={[
        {
          borderRadius: 18,
          width: '100%',
        },
        isDesktop()
          ? {
              elevation: 5,
              shadowColor: '#F0F0F0',
              shadowOffset: { width: 0, height: 12 },
              shadowOpacity: 1,
              shadowRadius: 32,
              paddingTop: 25,
              paddingHorizontal: 25,
              marginBottom: 150,
            }
          : {
              backgroundColor: COLORS.WHITE,
              paddingTop: 30,
              paddingHorizontal: 20,
            },
      ]}
    >
      <Formik
        initialValues={initData}
        onSubmit={(formValues) => {
          const emerPhone = convertMobileInputData(formValues.emer_phone);
          const startDate = new Date(
            `${state.start_time} ${formValues.checkin_time}`
          );
          const endDate = new Date(
            `${state.end_time} ${formValues.checkout_time}`
          );

          if (endDate < startDate) {
            Alert.alert(
              'Error',
              'Please select an end date greater than or equal to the start date.'
            );
          } else {
            setState({
              start_time: formValues.checkin_time,
              end_time: formValues.checkout_time,
              dinner_meal: formValues.dinner_meal,
              is_vegetarian: Boolean(formValues.is_vegetarian),
              emergency_first_name: formValues.emer_first_name,
              emergency_last_name: formValues.emer_last_name,
              emergency_phone_number: emerPhone.number,
              emergency_phone_country: emerPhone.country,
              emergency_relationship: formValues.emer_relationship,
              extra_dishes: extraDishes,
              extra_activities: extraActivities,
            });

            if (onSubmit) {
              onSubmit();
            }
          }
        }}
        validationSchema={yup.object().shape({
          is_vegetarian: yup
            .string()
            .required('Please select are you vegetarian.'),
          emer_first_name: yup
            .string()
            .required('Please enter emergency first name.'),
          emer_last_name: yup
            .string()
            .required('Please enter emergency last name.'),
          emer_phone: yup
            .string()
            .required('Please enter emergency phone.')
            .test(
              'phone-length',
              'Please enter emergency with 8 digits',
              (value: string) => {
                const emerPhone = convertMobileInputData(value);

                return emerPhone.number.length == 8;
              }
            ),
          emer_relationship: yup
            .string()
            .required(
              'Please enter your relationship to the emergency contact.'
            ),
        })}
      >
        {({ handleSubmit, handleChange, values, errors, isSubmitting }) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            const emerPhone = convertMobileInputData(values.emer_phone);

            dispatch(
              updateCartItemData({
                id: cartId,
                data: {
                  start_time: values.checkin_time,
                  end_time: values.checkout_time,
                  dinner_meal: values.dinner_meal,
                  is_vegetarian: Boolean(values.is_vegetarian),
                  emergency_first_name: values.emer_first_name,
                  emergency_last_name: values.emer_last_name,
                  emergency_phone_number: emerPhone.number,
                  emergency_phone_country: emerPhone.country,
                  emergency_relationship: values.emer_relationship,
                },
                step: 2,
              })
            );
          }, [values]);

          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            const errorKeys = Object.keys(errors);
            if (isSubmitting) {
              if (
                ['checkin_time', 'checkout_time'].some((key) =>
                  errorKeys.includes(key)
                )
              ) {
                handleScroll(bookingTimePosition);
              } else if (
                ['dinner_meal'].some((key) => errorKeys.includes(key))
              ) {
                handleScroll(dinnerMealPosition);
              } else if (
                ['is_vegetarian'].some((key) => errorKeys.includes(key))
              ) {
                handleScroll(vegetarianPosition);
              } else if (
                [
                  'emer_first_name',
                  'emer_last_name',
                  'emer_phone',
                  'emer_relationship',
                ].some((key) => errorKeys.includes(key))
              ) {
                handleScroll(emerPosition);
              }
            }
          }, [errors, isSubmitting]);

          return (
            <>
              <DatetimeInfo state={state} booking={booking} />
              {booking.room_availability && (
                <RoomInfor state={state} booking={booking} />
              )}
              {booking.included_meal &&
                (booking.included_meal.breakfast ||
                  booking.included_meal.lunch) && (
                  <View
                    style={{
                      marginBottom: 10,
                      zIndex: 3,
                    }}
                  >
                    <Text style={styles.itemTitle}>
                      Included Standard Meals:
                    </Text>
                    <View
                      style={{
                        flexDirection: 'column',
                      }}
                    >
                      {booking.included_meal.breakfast && (
                        <InCludedMealItem
                          name={'Breakfast'}
                          meal={booking.included_meal.breakfast}
                          mealWrapperStyle={{ backgroundColor: '#FFF5C7' }}
                          mealTextStyle={{ color: '#CC8100' }}
                          zIndex={2}
                        />
                      )}
                      {booking.included_meal.lunch && (
                        <InCludedMealItem
                          name={'Lunch'}
                          meal={booking.included_meal.lunch}
                          mealWrapperStyle={{ backgroundColor: '#D7FAE0' }}
                          mealTextStyle={{ color: '#007D3A' }}
                          zIndex={1}
                        />
                      )}
                    </View>
                  </View>
                )}
              {booking.dinner_meal &&
                booking.dinner_meal.length > 0 &&
                renderDinnerMeal}
              {renderExtraDishes}
              {/* {renderAddtionalMeals} */}
              {renderExtraActivities}
              {/* {renderAddtionalActivities} */}

              <Field name={'is_vegetarian'}>
                {({ field, form }: FieldProps) => (
                  <View
                    onLayout={(event) => {
                      const { layout } = event.nativeEvent;
                      const { height, y } = layout;

                      setVegetarianPosition({ y: y, height: height });
                    }}
                    style={{
                      marginBottom: 20,
                    }}
                  >
                    <Text style={styles.itemTitle}>Are you a vegetarian?</Text>
                    <RadioButton
                      options={[
                        {
                          label: 'Yes',
                          value: true,
                        },
                        {
                          label: 'No',
                          value: false,
                        },
                      ]}
                      selectedOption={field.value}
                      onSelect={(value) => {
                        form.setFieldValue(field.name, value);
                      }}
                      optionStyle={{ marginRight: isDesktop() ? 200 : 90 }}
                    />
                    <ErrorMessage
                      name={field.name}
                      render={(errorMessage: string) => (
                        <Text style={{ color: 'red', marginTop: 5 }}>
                          {errorMessage}
                        </Text>
                      )}
                    />
                  </View>
                )}
              </Field>
              {renderEmergencyContact}
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginBottom: 30,
                }}
              >
                <Button
                  style={[styles.buttonStyle, !isDesktop() && { width: '48%' }]}
                  className=""
                  arrowRight={false}
                  textStyle={[
                    styles.textButtonStyle,
                    !isDesktop() && { fontSize: 14 },
                  ]}
                  text="Previous Step"
                  onPress={() => {
                    handleSetStep(1);
                  }}
                />
                <Button
                  style={[styles.buttonStyle, !isDesktop() && { width: '48%' }]}
                  className=""
                  arrowRight={false}
                  textStyle={[
                    styles.textButtonStyle,
                    !isDesktop() && { fontSize: 14 },
                  ]}
                  text="Next Step"
                  onPress={() => {
                    handleSubmit();
                  }}
                />
              </View>
            </>
          );
        }}
      </Formik>
    </View>
  );
};
export default Step2;

const styles = StyleSheet.create({
  itemTitle: {
    fontFamily: FONTS.AvenirHeavy,
    fontWeight: '800',
    fontSize: 19,
    color: COLORS.LIGHT_BLACK,
    letterSpacing: 1,
    marginBottom: 20,
    textDecorationLine: 'underline',
  },
  itemSubTitle: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 19,
    textDecorationLine: 'underline',
    color: COLORS.LIGHT_BLACK,
    letterSpacing: 1,
    marginBottom: 12,
  },
  mealContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
  },
  mealWrapper: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 16,
  },
  mealText: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 20,
    lineHeight: 31,
  },
  typeMealWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 25,
    paddingVertical: 6,
    borderWidth: 1,
    borderColor: '#DDDDE3',
    borderRadius: 16,
    gap: 10,
  },
  typeMealText: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 16,
    color: COLORS.GREY,
  },
  checkbox: {
    width: 20,
    height: 20,
    borderWidth: 1,
    borderColor: '#DDDDE3',
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.LIGHT_GREY,
  },
  checkedCheckbox: {
    backgroundColor: COLORS.RED_PRIMARY,
  },
  checkIcon: {
    color: '#fff',
  },
  dinnerOption: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
  },
  contactText: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 16,
    color: COLORS.GREY,
  },
  contactInput: {
    marginBottom: 20,
    width: '100%',
    borderWidth: 1,
    borderColor: '#DDDDE3',
    borderStyle: 'solid',
    paddingHorizontal: 2,
    letterSpacing: 1.2,
    borderRadius: 4,
    fontSize: 16,
    paddingVertical: 5,
  },
  buttonStyle: {
    backgroundColor: COLORS.RED_PRIMARY,
    paddingVertical: 23,
    borderRadius: 13,
    width: 320,
    marginBottom: 20,
    overflow: 'hidden',
  },
  textButtonStyle: {
    color: COLORS.WHITE,
    fontSize: 17,
    fontFamily: FONTS.AvenirMedium,
    textTransform: 'uppercase',
    fontWeight: '500',
    letterSpacing: 1,
  },
  addtionalMealWrapper: {
    marginBottom: 20,
  },
  addtionalActivityWrapper: {
    marginBottom: 20,
  },
});
